import { PlayCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const StartBtn = ({ icon, displayText = false, ...others }) => {
  return (
    <Button
      color="primary"
      variant="solid"
      icon={!icon ? <PlayCircleOutlined /> : icon}
      {...others}
    >
      {displayText && "Iniciar"}
    </Button>
  );
};
